export default "__VITE_ASSET__DvCELiSi__"